<template>
  <a-layout class='index animated fadeIn'>
  </a-layout>
  </template>